import React, { useEffect, useState, useMemo } from 'react';
import { EditButton, BreadCrumbs, formatters } from '../../../Core/Controls';
import '../../commonStyle.scss';
import GijgoGrid from '../../../Core/Controls/GijgoGrid';
import JobDetail from '../Controllers/JOBS/JOBItems/JobDetails';
import { useLoginInfo } from '../../../Core/Hooks/useLoginInfo';
import { useHistory } from 'react-router-dom';
import StickyNotes from '../Controllers/Notes/stickyNotes';

let final = [
    { name: 'Home', path: '/' },
    { name: 'Invoices', active: true }
];
const getCrumbs = (code) => {
    let newColumn = [...final];
    if (code === 'p') {
        newColumn.splice(3, 0, { name: 'Sales-Paid', active: true });
    } else if (code === 'u') {
        newColumn.splice(3, 0, { name: 'Sales-Unpaid', active: true });
    } else {
        newColumn.splice(2, 0, { name: 'Paid', active: true });
    }
    return newColumn;
};

const basecolumns = [
    { key: 'action', name: 'Action', width: 80, addFileUploaderIcon: true },
    { key: 'ino', name: 'Number' },
    { key: 'idate', name: 'Invoice Date', formatter: formatters.Date_DDMMYYYY },
    { key: 'dd', name: 'Due Date', formatter: formatters.Date_DDMMYYYY },
    { key: 'total', name: 'Total', formatter: formatters.NumberWithPound, align: 'right' },
    { key: 'c', name: 'Customer' }
];

const SalesInvoiceScreen = (props) => {
    const [state, setState] = useState({
        modalToggle: false,
        invoiceID: null,
        VehicleID: props.VehicleID || null,
        ServiceAgentID: props.ServiceAgentID || null,
        isReload: null
    });
    const isCustomer = useLoginInfo().userRoles.includes('customer');
    const crumbs = getCrumbs(props.statusCode);
    const history = useHistory();

    useEffect(async () => {
        let getUrl;
        if (props.fromPage === 'job') {
            getUrl = `Invoices/SalesInvoiceByStatus${props.JobID ? `?JobID=${props.JobID}` : ''}`;
        } else {
            if (props.VehicleID) {
                getUrl = `Invoices/SalesInvoiceByStatus${props.VehicleID ? `?VehicleID=${props.VehicleID}` : ''}`;
            } else {
                getUrl = `Invoices/SalesInvoiceByStatus?status=${props.statusCode}`;
            }
        }
        setState((st) => ({
            ...st,
            getUrl: getUrl
        }));
    }, []);

    const pullInvoiceData = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };

    const actionButton = (data, row) => {
        return (
            <div className="Invoice-btn-update">
                <EditButton onClick={() => handleInvoiceUpdate(row)} toolTipTitle="Edit Invoice" />
            </div>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = actionButton;
        }
        if (!props.VehicleID || props.JobID) {
            tempCols.splice(5, 0, { key: 'regno', name: 'Reg No', width: '20%' });
        }
        if (props.statusCode != 'u') {
            tempCols.splice(4, 0, { key: 'dp', name: 'Date Paid', formatter: formatters.Date_DDMMYYYY });
        }
        return tempCols;
    }, []);

    const handleInvoiceUpdate = (val) => {
        history.push({
            pathname: `/update_sales_invoice/${val.invoiceID}`,
            search: ''
        });
    };
    return (
        <div className={props.fromPage === 'job' || props.VehicleID ? '' : 'screen'}>
            <>
                {!props.VehicleID && <BreadCrumbs crumbs={crumbs} />}
                {props.JobID && <JobDetail scheduleJobID={props.JobID} refresherFlag={state.refresherFlag} VehicleID={props.VehicleID} />}
                <GijgoGrid
                    dataConverter={(res) => ({
                        records: res.data.list.map((m) => ({ ...m, total: m.vat + m.net })),
                        total: res.data.total
                    })}
                    columns={columns}
                    getUrl={state.getUrl}
                    idFieldName="invoiceID"
                    fileUploaderConfigName="SalesInvoice"
                    isReload={state.isReload}
                    offset={props.fromPage === 'job' ? 410 : 350}
                />
            </>
        </div>
    );
};

export default SalesInvoiceScreen;
